    // --- Constants ---
    const WISHLIST_KEY = "wishlist";
    var userIsLoggedIn = false;
if (window.shopCustomer){
 userIsLoggedIn = true;
} 

    // --- Global State ---
    window.wishlist = window.wishlist || {}; 
    window.wishlist.wishlistItems = new Set();
    const add_to_wishlist = '加入到願望清單'
    // YOUR CUSTOM TEXT/SVG
    window.wishlist.wish_add_txt = `
        <svg viewBox="0 0 256 256" width="20" class="iwishOutline" xmlns="http://www.w3.org/2000/svg"><rect fill="none" height="256" width="256"></rect><path d="M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path></svg>
        <span>Add To Wishlist</span>`;
        
    window.wishlist.wish_added_txt = `
        <svg viewBox="0 0 256 256" width="20" class="iwishFill" xmlns="http://www.w3.org/2000/svg"><rect fill="none" height="256" width="256"></rect><path d="M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z" fill="#000000" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path></svg>
        <span>Added To Wishlist</span>`;

    // --- Functions ---
const wishlist_url = "https://www.skechers.com.hk/apps/wishlist"

    const loadWishlist = () => {
        try {
            const storedData = localStorage.getItem(WISHLIST_KEY);
            window.wishlist.wishlistItems = storedData ? new Set(JSON.parse(storedData)) : new Set([]);
        } catch (error) {
            console.error("Error loading wishlist:", error);
            window.wishlist.wishlistItems = new Set([]);
        }
    };

    const saveWishlist = () => {
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(Array.from(window.wishlist.wishlistItems)));
    };

window.syncWishlist = async ()=> {
try {
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    // 1. Get Server Wishlist
    const response = await fetch(wishlist_url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ method: "getWishlist" })
    });

    const data = await response.json();
    
    const serverWishlistArray = data.wishlist || []; 
    
    const serverSet = new Set(serverWishlistArray.map(item => String(item)));
    const localSet = window.wishlist.wishlistItems; 
    const itemsMissingLocally = serverWishlistArray.filter(item => !localSet.has(String(item)));
    
    itemsMissingLocally.forEach(item => localSet.add(String(item)));
    saveWishlist();
    if (itemsMissingLocally.length > 0) {
        //console.log("Synced items from server to local:", itemsMissingLocally);
    }

    const itemsMissingOnServer = [...localSet].filter(item => !serverSet.has(item));

    if (itemsMissingOnServer.length > 0) {
        //console.log("Syncing new items to server:", itemsMissingOnServer);

        const syncResponse = await fetch(wishlist_url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ 
                method: "syncWishlist", 
                wishlist: itemsMissingOnServer 
            })
        });
        
        const syncResult = await syncResponse.json();
        console.log("Server sync complete", syncResult);
    }

} catch (error) {
    console.error('Error in wishlist sync:', error);
}

}

    const updateUI = () => {
        const itemsCount = window.wishlist.wishlistItems.size;

        const wishlistOutput = document.getElementById('wishlist-output');
        if (wishlistOutput) {
            wishlistOutput.textContent = JSON.stringify(window.wishlist.wishlistItems, null, 2);
        }

        const counterEl = document.querySelector('.iwish-counter');
        if (counterEl) {
            if (itemsCount > 100) {
                counterEl.textContent = '99+';
                counterEl.style.fontSize = '9px'; 
                counterEl.style.display = "flex";
            }
            else if (itemsCount <= 0){
                counterEl.textContent = itemsCount;
                counterEl.style.fontSize = '10px'; 
                counterEl.style.display = "none";
            } 
            else {
                counterEl.textContent = itemsCount;
                counterEl.style.fontSize = '10px'; 
                counterEl.style.display = "flex";
            }
        }

        // 3. Update all .WishAdd buttons
        const buttons = document.querySelectorAll('.WishAdd');
        
        buttons.forEach(btn => {
            const productId = btn.dataset.product ? String(btn.dataset.product) : null;
            if (!productId) return;

            const isInWishlist = window.wishlist.wishlistItems.has(productId);

            if (isInWishlist) {
                btn.innerHTML = window.wishlist.wish_added_txt;
                btn.classList.add('added'); 
            } else {
                btn.innerHTML = window.wishlist.wish_add_txt;
                btn.classList.remove('added');
            }
        });
    };

window.removeProduct = async (productId) => {



    // UI Update Logic
    if (window.wishlist.wishlistItems.has(productId)) {
        window.wishlist.wishlistItems.delete(productId)
        saveWishlist();
        updateUI(); 
    } else {

    }
    if (userIsLoggedIn) {
        await fetch(wishlist_url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ method: "remove", product_id: productId }) 
        })
        .then(response => response.json())
        .then(data => {
            if (!data.hasOwnProperty("message") && data.hasOwnProperty("isLogin") && data.isLogin === false) {
                userIsLoggedIn = false;
                localStorage.removeItem("wishlist_isLogin"); 
            }
        })
        .catch(error => console.error('Error:', error));
    }
};

    window.toggleWishlist = async (e) => {
        e.preventDefault(); 
        const btn = e.currentTarget.closest('.WishAdd');
        if (!btn) return;

        const productId = btn.dataset.product ? String(btn.dataset.product) : null;
        if (!productId) return;

        if (window.wishlist.wishlistItems.has(productId)) {
            // Reuse the new remove function logic
            window.removeProduct(productId);
        } else {
            window.wishlist.wishlistItems.add(productId);
            saveWishlist();
            updateUI();
            if(userIsLoggedIn){
 await fetch(wishlist_url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },body:JSON.stringify({method:"add",product_id:productId})
})
  .then(response => response.json()) // <--- 1. Parse the stream as JSON
  .then(data => {
if(!data.hasOwnProperty("message")&& data.hasOwnProperty("isLogin") && data.isLogin === false ){
userIsLoggedIn = false
localStorage.removeItem("wishlist_isLogin")
}
    }

)
  .catch(error => console.error('Error:', error));

            }

        }
    };

    // --- Init ---
    const initializeApp = async () => {
        loadWishlist();
        if(userIsLoggedIn){
            const isLogin = localStorage.getItem("wishlist_isLogin");
            if(!isLogin){
                localStorage.setItem("wishlist_isLogin",true)
                await syncWishlist()
            }

        }
        else{
            const isLogin = localStorage.getItem("wishlist_isLogin");
                        if(isLogin){
                            localStorage.removeItem(WISHLIST_KEY)
                            localStorage.removeItem("wishlist_isLogin")
                            loadWishlist();
                        }
        }
        
        updateUI();

        document.querySelectorAll('.WishAdd').forEach(btn => {
            btn.removeEventListener('click', window.toggleWishlist);
            btn.addEventListener('click', window.toggleWishlist);
        });

        // Dispatch Event
        const event = new CustomEvent('wishlist-ready', {
            detail: { items: window.wishlist.wishlistItems }
        });
        document.dispatchEvent(event);
    };

    // Run when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeApp);
    } else {
        initializeApp();
    }

    // Example listener
    document.addEventListener('wishlist-ready', (e) => {
        const log = document.getElementById('event-log');
        if(log) log.textContent = "Event 'wishlist-ready' received! Wishlist count: " + e.detail.items.length;
    });